import React from 'react';
import { Eye } from 'lucide-react';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { TableCell, TableRow } from '../../ui/table';
import type { Document } from '../../../api/documentApi';

interface DocumentValidationWorkflowTableRowProps {
  document: Document;
  statusColors: Record<string, string>;
  onReview: (document: Document) => void;
  showValidator?: boolean;
  showDate?: boolean;
}

export default function DocumentValidationWorkflowTableRow({
  document,
  statusColors,
  onReview,
  showValidator = false,
  showDate = false,
}: DocumentValidationWorkflowTableRowProps) {
  // Pending: Dokumen, Entitas, Modul, Upload, Status, Aksi
  if (!showValidator && !showDate) {
    return (
      <TableRow>
        <TableCell className="font-medium">
          {document.document_name || document.file_name}
        </TableCell>
        <TableCell>{document.entity_name || '-'}</TableCell>
        <TableCell>
          <Badge>{document.module_type || 'GENERAL'}</Badge>
        </TableCell>
        <TableCell>{document.created_date?.split('T')[0] || '-'}</TableCell>
        <TableCell>
          <Badge className={statusColors[document.validation_status || ''] || statusColors.pending}>
            {document.validation_status || 'pending'}
          </Badge>
        </TableCell>
        <TableCell>
          <Button size="sm" variant="outline" onClick={() => onReview(document)}>
            <Eye className="w-4 h-4 mr-2" />
            Review
          </Button>
        </TableCell>
      </TableRow>
    );
  }

  // Approved: Dokumen, Entitas, Validator, Tanggal
  if (showValidator && !showDate) {
    return (
      <TableRow>
        <TableCell>{document.document_name || document.file_name}</TableCell>
        <TableCell>{document.entity_name || '-'}</TableCell>
        <TableCell>{document.validated_by_name || '-'}</TableCell>
        <TableCell>{document.validation_date || '-'}</TableCell>
      </TableRow>
    );
  }

  // Rejected: Dokumen, Alasan, Validator, Tanggal
  return (
    <TableRow>
      <TableCell>{document.document_name || document.file_name}</TableCell>
      <TableCell className="max-w-xs truncate">{document.rejection_reason || '-'}</TableCell>
      <TableCell>{document.validated_by_name || '-'}</TableCell>
      <TableCell>{document.validation_date || '-'}</TableCell>
    </TableRow>
  );
}
